import { createSlice } from '@reduxjs/toolkit';
import {
  createCounterpartyThunk,
  deleteCounterpartyThunk,
  editCounterpartyThunk,
  getAllCounterpartyThunk,
  getSelectedCounterpartyThunk,
} from './counterpartiesActions';
import { modifySelectedCounterpartyResponse } from './counterpartiesHelper';

export interface MyCounterpartiesState {
  loading: boolean;
  data: any;
  selectedCounterpartyData: any;
}

const initialState: MyCounterpartiesState = {
  loading: false,
  data: null,
  selectedCounterpartyData: null,
};

const myCounterpartiesSlice = createSlice({
  name: 'My Counterparties',
  initialState,
  reducers: {
    clearSelectedCounterpartyData: (state) => {
      state.selectedCounterpartyData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCounterpartyThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCounterpartyThunk.fulfilled, (state, action) => {
        state.data = action.payload?.data?.allCounterParty || [];
        state.loading = false;
      })
      .addCase(getAllCounterpartyThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createCounterpartyThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCounterpartyThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createCounterpartyThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(editCounterpartyThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(editCounterpartyThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editCounterpartyThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteCounterpartyThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCounterpartyThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteCounterpartyThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getSelectedCounterpartyThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSelectedCounterpartyThunk.fulfilled, (state, action) => {
        state.selectedCounterpartyData = modifySelectedCounterpartyResponse(action.payload);
        state.loading = false;
      })
      .addCase(getSelectedCounterpartyThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { clearSelectedCounterpartyData } = myCounterpartiesSlice.actions;
export default myCounterpartiesSlice.reducer;
